<section class="k-d-grid k-gap-y-xl">
    <div>
        <div class="k-d-flex k-align-items-center">
            <h5>{{providerDetails?.providerName}}
                @if(providerDetails?.providerId){
                <span>(ID: {{providerDetails?.providerId}})</span>
                }
            </h5>
            <!-- @if(providerDetails?.providerId){ -->
            <button class="!k-p-1" [svgIcon]="copyIcon" themeColor="primary" fillMode="flat" kendoButton kendoTooltip
                #anchor showOn="none" size="medium" [tooltipTemplate]="template"
                (mouseover)="this.tooltipDir.show(anchor)" (focus)="tooltipDir.show(anchor)"
                (mouseleave)="this.tooltipDir.hide()" position="bottom"
                (click)="copyClipboard(providerDetails?.providerId)" aria-label="Copy provider ID">
            </button>
            <!-- } -->
            <ng-template #template>
                <span>{{ tooltipText }}</span>
            </ng-template>
        </div>
        <h6 style="color:var(--tb-kendo-neutral-110)" class="!k-m-0">{{providerDetails?.serviceTypeName}}</h6>
    </div>
    <div>
        <p class="!k-m-0 secondary-text">Title</p>
        <p class="!k-m-0">{{providerDetails?.titleName}}</p>
    </div>
    <div>
        <p class="!k-m-0 secondary-text">Agency Name</p>
        <p class="!k-m-0">{{providerDetails?.agencyName}}</p>
    </div>
    <div class="k-d-flex">
        <div class="k-w-1/2">
            <p class="!k-m-0 secondary-text">Licence Number</p>
            <p class="!k-m-0">{{providerDetails?.licenseNumber}}</p>
        </div>
        <div class="k-w-1/2">
            <p class="!k-m-0 secondary-text">NPI</p>
            <p class="!k-m-0">{{providerDetails?.npi}}</p>
        </div>
    </div>
    <div class="k-d-flex">
        <div class="k-w-1/2">
            <p class="!k-m-0 secondary-text">UDO?</p>
            <p class="!k-m-0">{{providerDetails?.udo ? 'Yes' : 'No'}}</p>
        </div>
        <div class="k-w-1/2">
            <p class="!k-m-0 secondary-text">Supervisor Full Name</p>
            <p class="!k-m-0">{{providerDetails?.supervisorFullName}}</p>
        </div>
    </div>
</section>